import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import { useTestCycleExecution } from '../context/TestCycleExecutionContext';

/**
 * Global sticky banner shown when a test cycle is executing. Allows user to stop
 * execution from any page (Dashboard, Collections, etc.) even after navigating
 * away from TestCycleDetailsPage.
 */
const TestCycleExecutionBanner: React.FC = () => {
  const { activeExecution, requestStop } = useTestCycleExecution();

  if (!activeExecution?.executing) {
    return null;
  }

  return (
    <Box
      component="div"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1,
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 1,
        mb: 1.5,
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Test Plan executing...
      </Typography>
      <Button
        type="button"
        size="small"
        variant="contained"
        color="error"
        startIcon={<StopIcon />}
        onClick={requestStop}
        sx={{
          color: 'white',
          '&:hover': { backgroundColor: 'error.dark' },
        }}
      >
        Stop
      </Button>
    </Box>
  );
};

export default TestCycleExecutionBanner;
